<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	export let label = '';
	export let ariaLabel = '';
	export let options: Array<{ title: string; value: any; disabled?: boolean }> = [];
	export let value: any = undefined;
	export let disabled = false;

	const dispatch = createEventDispatcher<{ change: any }>();

	$: currentValue = value && typeof value === 'object' && 'value' in value ? value.value : value;

	function select(option: { title: string; value: any; disabled?: boolean }) {
		if (option.disabled) return;
		dispatch('change', option);
	}
</script>

<div class="token-field">
	{#if label}<span class="token-label">{label}</span>{/if}
	<div class="token-list" role="group" aria-label={ariaLabel || label}>
		{#each options as option}
			<button
				type="button"
				class:active={String(currentValue ?? '') === String(option.value ?? '')}
				disabled={disabled || option.disabled}
				aria-pressed={String(currentValue ?? '') === String(option.value ?? '')}
				on:click={() => select(option)}>{option.title}</button
			>
		{/each}
	</div>
</div>

<style>
	.token-field {
		display: flex;
		min-width: 0;
		flex-direction: column;
		gap: 7px;
	}
	.token-label {
		color: var(--color-text-secondary, #94a3b8);
		font-size: 11px;
		font-weight: 650;
	}
	.token-list {
		display: flex;
		flex-wrap: wrap;
		gap: 7px;
	}
	.token-list button {
		min-height: 34px;
		padding: 6px 11px;
		border: 1px solid var(--color-3, rgba(148, 163, 184, 0.3));
		border-radius: 999px;
		background: var(--color-1, rgba(148, 163, 184, 0.06));
		color: inherit;
		font: inherit;
		font-size: 12px;
		cursor: pointer;
		transition:
			border-color 120ms ease,
			background 120ms ease;
	}
	.token-list button:hover:not(:disabled) {
		border-color: var(--color-primary, #3b82f6);
	}
	.token-list button.active {
		border-color: var(--color-primary, #3b82f6);
		background: color-mix(in srgb, var(--color-primary, #3b82f6) 16%, transparent);
		color: var(--color-text-primary, #fff);
		font-weight: 700;
	}
	.token-list button:disabled {
		opacity: 0.42;
		cursor: not-allowed;
	}
</style>
